import { render, staticRenderFns } from "./ProductSliderImageDetail.vue?vue&type=template&id=b4d62f90&scoped=true&"
import script from "./ProductSliderImageDetail.vue?vue&type=script&lang=js&"
export * from "./ProductSliderImageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d62f90",
  null
  
)

export default component.exports